import {
  LOAD_EMPLOYEE_TYPES,
  DELETE_EMPLOYEE_TYPE,
  UPLOAD_FILE,
  DOWNLOAD_FILE,
  LOAD_EMPLOYEE_TYPE,
  CREATE_EMPLOYEE_TYPE,
  EDIT_EMPLOYEE_TYPE,
  DESTROY_MANY
} from "./actions";

const initialState = {
  message: "",
  data: [],
  employeeType: {
    type_name: ""
  },
  alertMessage: "",
  errorMessage: "",
  totalSize: 0,

  errorImport: "",
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_EMPLOYEE_TYPES.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };

    case LOAD_EMPLOYEE_TYPES.SUCCESS:
      return {
        ...state,
        data: action.payload.employeeTypes.data,
        employeeType: initialState.employeeType,
        totalSize: action.payload.employeeTypes.total_row,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: false
      };
    case LOAD_EMPLOYEE_TYPE.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };

    case LOAD_EMPLOYEE_TYPE.SUCCESS:
      return {
        ...state,
        employeeType: action.payload.employeeType.data,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: false
      };
    case LOAD_EMPLOYEE_TYPE.FAILURE:
      return {
        ...state,
        errorMessage: action.payload.error,
        alertMessage: "",

        errorImport: "",
        loading: false
      };
    case CREATE_EMPLOYEE_TYPE.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };

    case CREATE_EMPLOYEE_TYPE.SUCCESS:
      return {
        ...state,
        alertMessage: action.payload.employeeType.message,
        errorMessage: "",

        errorImport: "",
        loading: false
      };
    case CREATE_EMPLOYEE_TYPE.FAILURE:
      return {
        ...state,
        errorMessage: action.payload.error,
        alertMessage: "",

        errorImport: "",
        loading: false
      };
    case EDIT_EMPLOYEE_TYPE.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };

    case EDIT_EMPLOYEE_TYPE.SUCCESS:
      return {
        ...state,
        alertMessage: action.payload.employeeType.message,
        errorMessage: "",

        errorImport: "",
        loading: false
      };
    case EDIT_EMPLOYEE_TYPE.FAILURE:
      return {
        ...state,
        errorMessage: action.payload.error,
        alertMessage: "",

        errorImport: "",
        loading: false
      };
    case DELETE_EMPLOYEE_TYPE.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };

    case DELETE_EMPLOYEE_TYPE.SUCCESS:
      const newEmployeeTypes = state.data.filter(
        employeeTypes =>
          employeeTypes.employee_type_id !==
          action.payload.employeeType.data.employee_type_id
      );
      return {
        ...state,
        data: newEmployeeTypes,
        alertMessage: action.payload.employeeType.message,
        totalSize: state.totalSize - 1,

        errorImport: "",
        loading: false
      };
    case DELETE_EMPLOYEE_TYPE.FAILURE:
      return {
        ...state,
        errorMessage: action.payload.error,
        errorImport: "",
        loading: false
      };
    case UPLOAD_FILE.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };
    case UPLOAD_FILE.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        totalSize: action.payload.data.total_row,
        alertMessage: action.payload.data.message,
        errorMessage: "",

        errorImport: "",
        loading: false
      };
    case UPLOAD_FILE.FAILURE:
      return {
        ...state,
        errorImport: action.payload.error,
        errorMessage: "",
        alertMessage: "",

        loading: false
      };
    case DOWNLOAD_FILE.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };
    case DOWNLOAD_FILE.SUCCESS:
      return {
        ...state,
        loading: false
      };
    case DOWNLOAD_FILE.FAILURE:
      return {
        ...state,
        loading: false
      };

    case DESTROY_MANY.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",
        loading: true
      };

    case DESTROY_MANY.SUCCESS:
      const { data } = action.payload.data;
      return {
        ...state,
        data: state.data.filter(val => !data.includes(val.employee_type_id)),
        alertMessage: "success",
        totalSize: state.totalSize - 1,
        loading: false
      };

    case DESTROY_MANY.FAILURE:
      return {
        ...state,
        errorMessage: action.payload.error,
        loading: false
      };
    default:
      return state;
  }
};
